// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 764) return "public/css/build/release-cloudweb-15568-138-1-0-0-1.202308071627/main.css";
	// return url for filenames based on template
	return undefined;
};